module.exports = __webpack_public_path__ + "img/logo.906625de.png";